import {
  cleanFilter,
  createFilterContext,
  FilterActionKind,
  type FilterSideEffect as SharedFilterSideEffect,
} from '@porsche-code/kado-filter-context';
import { defaultParseSearch } from '@tanstack/react-router';

type FilterState = {
  limit?: number;
  skip?: number;
  columnFilters?: {
    id: string;
    value?: unknown;
  }[];
  sorting?: { id: string; desc: boolean }[];
};

type SideEffect = SharedFilterSideEffect<FilterState>;

const { FilterProvider, useFilterContext } = createFilterContext<
  FilterState,
  FilterState
>({
  parseSearch: defaultParseSearch,
  getInitialState: (searchParams) => searchParams || {},
  cleanUp: (filter) =>
    cleanFilter(filter, (value) => {
      if (
        Array.isArray(value) &&
        value[0] &&
        'id' in value[0] &&
        !value[0].id
      ) {
        return false;
      }

      return true;
    }),
});

export {
  FilterActionKind as SupportRequestFilterActionKind,
  FilterProvider as SupportRequestFilterProvider,
  useFilterContext as useSupportRequestFilterContext,
};

export type {
  SideEffect as SupportRequestFilterSideEffect,
  FilterState as SupportRequestFilterState,
};
